import React, { useState, useEffect } from "react";
import moment from 'moment';
import 'moment/locale/es';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe, faWarehouse, faTrash, faTicketAlt, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { Row, Col, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import { useAnalytics } from "libs/analytics";
import { useCart } from "libs/cartLib";
import { useAppContext } from "libs/contextLib";

import './Cart.css'
import CartSummaryCard from './CartSummaryCard';
import { CartItemsList } from './CartItemsList';

export default function CartSummaryBox(props) {
    const { info, showEmptyCart = true, stacked = false, mode = 'checkout', ...otherProps } = props

    const [ticketsTotal, setTicketsTotal] = useState(0)
    const [cartTotal, setCartTotal] = useState(0)
    // const [cart, setCart] = useState(null)

    const { trackEvent } = useAnalytics();

    const { cart } = useAppContext();
    // const cart = {}
    
    const { getCart, getTotalItems, removeCartItems } = useCart()

    useEffect(() => {        
        // onLoad()         
        
    }, [cart]);

    async function onLoad() {
        // let mycart
        // try {
        //     mycart = await getCart()
        //     setCart(mycart || {})
        // } catch (e) {
        //     // no cart
        // }
    }


    
    
    function renderCartSummary(cart) {
        // <Col md="2">{!viewerShow ? <Button variant="primary" data-ticket-id={t.id} onClick="">Comprar</Button> : null }</Col>

        // let items = props.cart.items || [];
        // let orderTotal = 0
        // if (tickets) {
        //     items = tickets.filter(t => t.selected ).map( t => {
        //         orderTotal = 
        //         return <>
        //         <Row key={t.ticket_id}>
        //             <Col md="6">{t.fullname}</Col>
        //             <Col md="6" className="price">{t.selected} x {t.price_text}</Col>
        //         </Row>           
        //         </>
        //     })
        // }
//         const cart = await getCart()
        // console.log(cart)

        return <div className={`cart-main-layout ${stacked && 'cart-main-layout--stacked'}`}>
            <div className="cart-left">
                    <CartItemsList
                        cart={cart}
                        props={props}                        
                        showEmptyCart={showEmptyCart}
                    />
                    {showEmptyCart && <div className="cart-continue-row">
                        <LinkContainer to="/">
                            <a className="cart-continue-link">&larr; Seguir comprando</a>
                        </LinkContainer>
                    </div>}  
            </div>
            <div className="cart-right">
                <CartSummaryCard
                  cart={cart}
                  getTotalItems={getTotalItems}
                  mode={mode}
                />
            </div>
        </div>
    }    

    return renderCartSummary(cart)
}